import { render, staticRenderFns } from "./EachMessageComponent.vue?vue&type=template&id=cffe8f7c&"
import script from "./EachMessageComponent.vue?vue&type=script&lang=js&"
export * from "./EachMessageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports